import type React from "react";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { getRecentParams } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";

export const DiscoverKeywordsStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();

    const searchKeywords = (): void => {
        const filterParams = {
            IncludeOrganic: true,
            IncludeBranded: false,
            IncludeNoneBranded: true,
        };
        const finalParamsKeyword = {
            ...{
                ...proNavigator.getState("organicsearch_websites_v2_traffic_keywords").defaultQueryParams,
            },
            ...(getRecentParams() ?? {}),
        };

        props.onStepComplete("growth.homepage.wizard.button.keywords");
        proNavigator.go("organicsearch_websites_v2_traffic_keywords", {
            ...finalParamsKeyword,
            ...filterParams,
        });
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.discover_keywords.title")}
            description={i18n("growth.homepage.activationWizard.step.discover_keywords.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.discover_keywords.button"),
                            onClick: searchKeywords,
                            type: "primary",
                        },
                    ]}
                />
            }
        />
    );
};
